import { ConditionalProperty } from 'Automations/nodeDefinitions/conditions'
import { Condition } from '../..'

export const getAvailableOperators = ({
  conditionId,
  propertyKey,
  conditions,
  property
}: {
  conditionId: string
  propertyKey: string
  conditions: Condition[]
  property: ConditionalProperty
}): string[] => {
  const otherConditionsOnProperty = conditions.filter(
    c => c.id !== conditionId && c.property === propertyKey && c.operator !== ''
  )

  const excludedByUse = new Set(otherConditionsOnProperty.map(c => c.operator))

  const excludedByExclusiveOf = new Set(
    otherConditionsOnProperty.reduce<string[]>((acc, c) => {
      const operatorDef = property.operators[c.operator]
      const exclusions = operatorDef?.exclusiveOf ?? []
      return [...acc, ...exclusions]
    }, [])
  )

  return Object.keys(property.operators).filter(operator => {
    if (excludedByUse.has(operator)) return false
    if (excludedByExclusiveOf.has(operator)) return false

    return true
  })
}
